<template>
    <el-dialog title="添加用户" width="70%" :append-to-body="true" :visible.sync="newUserVisible" center v-loading="newUserLoading" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" 
    element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-form ref="newForm" :rules="newFormRules" :model="newForm" size="mini" label-width="180px">
            <el-form-item label="登录名：" prop="xmid">
                <el-input v-model="newForm.xmid" placeholder="登录名" :maxlength="10" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="xmname">
                <el-input v-model="newForm.xmname" placeholder="用户名" :maxlength="10" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="用户部门(综合档案)：" prop="bmId">
                <el-select v-model="newForm.bmId" placeholder="用户部门(综合档案)" clearable filterable>
                    <el-option v-for="item in xmBmList" :key="item.bmid" :label="item.bmname" :value="item.bmid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户职务：" prop="zwId">
                <el-select v-model="newForm.zwId" placeholder="用户职务" clearable filterable>
                    <el-option v-for="item in zwList" :key="item.zwid" :label="item.zwname" :value="item.zwid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="权限部门：" prop="bmList">
                <el-select v-model="newForm.bmIdList" placeholder="权限部门"  multiple>
                    <el-option v-for="item in bmList" :key="item.clid" :label="item.clname" :value="item.clid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户角色：" prop="roleList">
                <div class="roleDiv">
                    <el-transfer v-model="newForm.roleList" :data="roleList" :props="{key: 'roleId',label: 'roleName'}"
                    :titles="['未含角色', '已含角色']"  :format="{noChecked: '${total}',hasChecked: '${checked}/${total}' }"
                    >
                        <span slot-scope="{ option }">
                        <el-tooltip :content="option.roleName+':('+option.description+')'" placement="right" effect="light">
                            <span>{{ option.roleName }}</span> 
                        </el-tooltip>
                        </span>
                    </el-transfer>
                    <el-button type="primary" plain size="mini" v-show="canAddRole" @click="changeRoleVisible(true)"><i class="el-icon-plus"></i>&nbsp; 添加角色</el-button>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="addUser">提交</el-button>
        </span>

        <!--添加角色-->
        <new-role 
        :newRoleVisible="newRoleVisible"
        :flushRoleList="flushRoleList" 
        :rightList="rightList" 
        @changeVisible="changeRoleVisible"
        ></new-role>
    </el-dialog>
</template>
<script>
import NewRole from '../role/NewRole.vue'
export default {
    components: { NewRole },
    name:'NewUser',
    props:{
        roleList:Array,
        bmList:Array,
        xmBmList:Array,
        zwList:Array,
        rightList:Array,
        newUserVisible:Boolean,

        flushUserList:Function,
        flushRoleList:Function,
        canAddRole:{type:Boolean,default:false}
    },
    data(){
        return {
            newUserLoading:false,
            newForm:{
                xmid:"",
                xmname:"",
                bmId:null,
                zwId:null,
                bmIdList:[],
                roleList:[]
            },
            newFormRules:{
                xmid:[{required:true,message:"登录名必填",trigger:'blur'}],
                xmname:[{required:true,message:"用户名称必填",trigger:'blur'}],
                bmId:[{required:true,message:"部门(综合项目)必填",trigger:'change'}],
                zwId:[{required:true,message:"职务必填",trigger:'change'}],
                roleList:[{ type: 'array', required: true, message: '至少需要1个角色', trigger: 'change' }]
            },

            newRoleVisible:false,
        }
    },
    mounted(){},
    methods:{
        changeRoleVisible(val){
            this.newRoleVisible=val
        },
        close(){
            this.$emit('changeVisible',false)
        },
        addUser(){
            this.$refs.newForm.validate(async valid=>{
                if(valid){
                    const confirmresult = await this.$confirm('将要添加新的用户，请确定是否继续？','提示',{
                        confirmButtonText:'确定',cancelButtonText:'取消',type:'warning'
                    }).catch(err=>err)
                    if(confirmresult!=='confirm'){
                        return this.$message.info('已取消操作')
                    }else{
                        this.newUserLoading=true
                        const {data:res}=await this.$http.post('um/add',this.newForm).catch(err => err)
                        if(res){
                            this.$message.success('操作成功！')
                            this.flushUserList()
                            this.$refs.newForm.resetFields()
                            this.newForm={
                                xmid:"",
                                xmname:"",
                                bmId:null,
                                zwId:null,
                                bmIdList:[],
                                roleList:[]
                            }
                            this.close()
                        }
                        this.newUserLoading=false
                    }
                }else{
                    return false
                }
            })
        },
    },
}
</script>
<style scope>
.el-transfer-panel{
    width: 280px;
    }
    .el-transfer-panel__list.is-filterable{
    height: 280px;
    }
    .roleDiv{
        display: flex;
        justify-content:space-between ;
    }
</style>